import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  align-items: center;
  padding: 20px;
  opacity: ${(props) => (props.locked ? 0.6 : 1)};

  &:last-child {
    border-bottom: none;
  }

  .left-col {
    display: flex;
    align-items: center;
    gap: 12px;

    .icon-box {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #cfd3dd;

      i {
        font-size: 14px;
      }

      &.info {
        background: #f0f2ff;
        color: #2d39c4;
      }
    }

    .checkbox {
      width: 18px;
      height: 18px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid #cfd3dd;
      &.checked {
        background: #cfd3dd;
        border-color: #cfd3dd;
        color: white;
        width: 20px;
        height: 20px;
        border: none;
        i {
          font-size: 8px;
        }
      }
    }

    .title {
      font-size: 17px;
      color: #1f1f52;
    }
  }

  .date-col {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .date-text {
      font-size: 14px;
      color: #3e3e5b;

      &.delayed {
        color: #ff4d4f;
      }
    }

    .date-label {
      font-size: 14px;
      color: #707582;
    }
  }

  .status-col {
    display: flex;
    justify-content: flex-end;

    .badge {
      padding: 6px 16px;
      border-radius: 20px;
      font-size: 12px;

      strong {
        font-weight: 600;
        color: #4a5568;
      }
    }
  }
`;
